const mutationTypes = {
  SET_LOADING: 'setLoading',
  RESET_LOADING: 'resetLoading',
  SET_CHILDREN: 'setChildren',
  SET_DRIVING_LICENSE_CASES: 'setDrivingLicenseCases',
  SET_STATUS: 'setStatus',
  SET_DRIVING_LICENSE_STATUS: 'setDrivingLicenseStatus',
  LOCK_SUBMITTED: 'lockSubmitted'
}

const asPendingItems = (items) =>
  items.map((i) => ({
    ...i,
    status: undefined,
    isLocked: false
  }))

const withStatus = (items, cprNumber, status) =>
  items.map((i) =>
    i.cprNumber === cprNumber
      ? {
          ...i,
          status: status
        }
      : i
  )

const lockAnswered = (items) =>
  items.map((i) =>
    i.status !== undefined
      ? {
          ...i,
          isLocked: true
        }
      : i
  )

const mutations = {
  [mutationTypes.SET_LOADING]: (state, loadingMessage) => {
    state.loader.isLoading = true
    state.loader.message = loadingMessage
  },
  [mutationTypes.RESET_LOADING]: (state) => {
    state.loader.isLoading = false
    state.loader.message = undefined
  },
  [mutationTypes.SET_CHILDREN]: (state, children) => {
    state.children = asPendingItems(children)
  },
  [mutationTypes.SET_DRIVING_LICENSE_CASES]: (state, cases) => {
    state.drivingLicenseCases = asPendingItems(cases)
  },
  [mutationTypes.SET_STATUS]: (state, { cprNumber, status }) => {
    state.children = withStatus(state.children, cprNumber, status)
  },
  [mutationTypes.SET_DRIVING_LICENSE_STATUS]: (state, { cprNumber, status }) => {
    state.drivingLicenseCases = withStatus(state.drivingLicenseCases, cprNumber, status)
  },
  [mutationTypes.LOCK_SUBMITTED]: (state) => {
    state.children = lockAnswered(state.children)
    state.drivingLicenseCases = lockAnswered(state.drivingLicenseCases)
  }
}

export { mutationTypes }
export default mutations
